import { roundToPlaces } from "../../utils/roundToPlaces.js";
import type { CourseTerm } from "../CourseTerm.js";
import { CourseType } from "../CourseType.js";
import type { Currency } from "../Currency.js";
import type { ExchangeRate } from "../ExchangeRatesSetting.js";
import type { TaxedPrice } from "../TaxedPrice.js";
import { courseTypeContentMap } from "../names/courseTypeContentMap.js";
import { courseVatRate } from "./courseVatRate.js";
import { resolveExchangeRate } from "./resolveExchangeRate.js";
import { taxedPrice } from "./taxedPrice.js";

export function calculateCourseOrderPrice(
	courseTerm: Pick<CourseTerm, "courseType" | "priceWithTax">,
	currency: Currency,
	exchangeRates: ExchangeRate[],
): TaxedPrice {
	let priceInCzk: number;
	if (courseTerm.courseType === CourseType.Workshop) {
		if (courseTerm.priceWithTax === undefined) {
			throw new Error("Workshop course term is missing a price.");
		}
		priceInCzk = courseTerm.priceWithTax;
	} else {
		priceInCzk = courseTypeContentMap[courseTerm.courseType].priceWithTax;
	}
	const exchangeRate = resolveExchangeRate(currency, exchangeRates);
	const withTax = roundToPlaces(priceInCzk / exchangeRate, 2);
	return taxedPrice({ taxRate: courseVatRate, withTax });
}
